// Demo data for customer invoices and payments
import type { InvoiceUI, PaymentUI } from '@/types/ui/customer-detail';

// Mock Invoices by customer ID
export const mockInvoicesByCustomerId: Record<string, InvoiceUI[]> = {
  '1': [
    {
      id: 'INV-001',
      date: '2023-11-01',
      dueDate: '2023-12-01',
      amount: 76000,
      status: 'overdue',
    },
    {
      id: 'INV-002',
      date: '2023-11-15',
      dueDate: '2023-12-15',
      amount: 68000,
      status: 'overdue',
    },
    {
      id: 'INV-003',
      date: '2023-12-01',
      dueDate: '2023-12-31',
      amount: 70000,
      status: 'overdue',
    },
  ],
};

// Mock Payments by customer ID
export const mockPaymentsByCustomerId: Record<string, PaymentUI[]> = {
  '1': [
    {
      id: 'PAY-001',
      date: '2023-11-15',
      amount: 50000,
      method: 'Wire Transfer',
      reference: 'WT-2023-001',
      allocations: [
        { invoiceId: 'INV-001', invoiceDate: '2023-10-01', amount: 30000 },
        { invoiceId: 'INV-002', invoiceDate: '2023-10-15', amount: 20000 },
      ],
    },
    {
      id: 'PAY-002',
      date: '2023-10-20',
      amount: 35000,
      method: 'ACH',
      reference: 'ACH-2023-002',
      allocations: [{ invoiceId: 'INV-003', invoiceDate: '2023-09-01', amount: 35000 }],
    },
  ],
};
